
import {take, tap, switchMap, filter} from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';

import * as page from '../actions/page.actions';
import * as fromRoot from '../reducers/index';
import { Store } from '@ngrx/store';

@Injectable()
export class PageEffects {
  private actions$ = inject(Actions);
  private store = inject<Store<fromRoot.State>>(Store);
  private router = inject(Router);


  
  changePage$ = createEffect(() => this.actions$.pipe(
    ofType(page.ActionTypes.LOAD_PAGE),
    tap((action: page.LoadPageAction) => this.router.navigateByUrl(action.payload))), { dispatch: false });

  
  previousPage$ = createEffect(() => this.actions$
    .pipe(
      ofType(page.ActionTypes.LOAD_PREVIOUS_PAGE),
      switchMap(() => this.store.select(fromRoot.getPagePrevious).pipe(take(1))),
      filter((previousPath): previousPath is string => previousPath !== null),
      tap((previousPath) => this.router.navigateByUrl(previousPath))
    ), { dispatch: false });
}
